import React from 'react'
import Slider from 'react-slick'
import { connect } from 'react-redux'
import * as actions from '../actions/CarouselActions'

class Carousel extends React.Component{
  constructor(props){
    super(props)
    this.getSettings = this.getSettings.bind(this)
  }

  getSettings(){
    return{
      accessibility: true,
      arrows: true,
      autoplay: false,
      dots: true,
      draggable: true,
      fade: false,
      infinite: true,
    }
  }

  render(){
    const settings = this.getSettings()

    let content = this.props.data.map((d, i)=>{
      return(
        <div key={`carousel-content${i}`}> 
          <img src={`${d.img}`} />  
          <div className="center-align">
            <h5>{d.title}</h5>
            <p>{d.content}</p>
          </div>
        </div>
      )
    })
  
    return(
      <div id={this.props.carouselId} className={`carousel-overlay ${this.props.visible?null:'hidden-carousel'}`}>
        <button type="button" className="close-button" onClick={this.props.deactivateCarousel.bind(this, this.props.carouselId)}><i className="fa fa-times"></i></button>
        <div className="carousel-container">
        <Slider {...settings}>
          {content}   
        </Slider>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return state.CarouselReducer
}

function mapDispatchToProps(dispatch){
  return{
    deactivateCarousel:(carouselId)=>{dispatch(actions.hideCarousel(carouselId))}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Carousel)


// WEBPACK FOOTER //
// ./app/components/Carousel.js